/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_User_GroupInputs */

const en_users_form_user_group = /** @type {(inputs: Users_Form_User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Group`)
};

const pt_br2_users_form_user_group = /** @type {(inputs: Users_Form_User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupo do Usuário`)
};

/**
* | output |
* | --- |
* | "User Group" |
*
* @param {Users_Form_User_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_user_group = /** @type {((inputs?: Users_Form_User_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_User_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_user_group(inputs)
	return pt_br2_users_form_user_group(inputs)
});